import React from 'react';
import './css/pageLoading.css';

interface PageLoadingProps {
  message: string;
}

export default function PageLoading({
  message,
}: PageLoadingProps) {
  void message;
  return (
    <div className="page-loading-wrapper">
      <div className="page-loading" aria-label={message} role="status">
        <div className="page-skeleton page-skeleton-title" />
        <div className="page-skeleton page-skeleton-line" />
        <div className="page-skeleton page-skeleton-line" />
        <div className="page-skeleton page-skeleton-line short" />
      </div>
    </div>
  );
}
